import { menuItem } from '@/components/SecondaryMenu';

export const MENU_ITEMS: menuItem[] = [
  {
    title: 'Asset & Infrastructure Monitoring',
    href: '/iot/asset-infrastructure-monitoring',
  },
  {
    title: 'Energy & Environment Management',
    href: '/iot/energy-environment-management',
  },
  {
    title: 'Space and Occupancy Intelligence',
    href: '/iot/space-occupancy-intelligence',
  },
  {
    title: 'IoT Security & Risk Management',
    href: '/iot/iot-security-risk-management',
  },
  {
    title: 'Smart Automation Controls',
    href: '/iot/smart-automation-controls',
  },
];
